const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export function focusFirstDialogElement(dialog: HTMLElement): void {
  const firstFocusable = dialog.querySelector<HTMLElement>(FOCUSABLE_SELECTOR);
  if (firstFocusable) {
    firstFocusable.focus();
    return;
  }

  dialog.tabIndex = -1;
  dialog.focus();
}

export function getDialogExitDuration(): number {
  return typeof window !== 'undefined'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 1
    : 160;
}

export function handleDialogKeydown(
  event: KeyboardEvent,
  dialog: HTMLElement,
  onEscape: () => void,
): void {
  if (event.key === 'Escape') {
    event.preventDefault();
    onEscape();
    return;
  }

  if (event.key !== 'Tab') {
    return;
  }

  const focusableElements = Array.from(
    dialog.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR),
  );
  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  if (!firstFocusable || !lastFocusable) {
    event.preventDefault();
    dialog.focus();
  } else if (event.shiftKey && document.activeElement === firstFocusable) {
    event.preventDefault();
    lastFocusable.focus();
  } else if (!event.shiftKey && document.activeElement === lastFocusable) {
    event.preventDefault();
    firstFocusable.focus();
  }
}
